"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { PostAuthors } from "@/views/post/partials/PostAuthors/PostAuthors";
import { PostBody } from "@/views/post/partials/PostBody/PostBody";
import { RelatedMatches } from "@/views/post/partials/RelatedMatches/RelatedMatches";
import { usePostData } from "@/views/post/context/PostDataContext";
import { VideoHeader } from "../../partials/VideoHeader/VideoHeader";
import { SidebarContent } from "./SidebarContent";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import { AdSlot } from "@/features/ads/AdSlot";
import { DiscussionWidget } from "@/features/discussion/DiscussionWidget";
import { SectionStrip, type BrandedStyle } from "@/components/layout/SectionStrip";
import { VIDEO_HERO } from "@/features/theme/sectionKeys";
interface VideoLayoutDefaultWithSidebarProps {
  sectionStyles?: Record<string, BrandedStyle>;
  breadcrumbs?: React.ReactNode;
}
export function VideoLayoutDefaultWithSidebar(t0) {
  const $ = _c(32);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    sectionStyles,
    breadcrumbs
  } = t1;
  const {
    post
  } = usePostData();
  const labels = useLabels();
  useNavigation();
  const t2 = sectionStyles?.[VIDEO_HERO];
  let t3;
  if ($[2] !== breadcrumbs) {
    t3 = <VideoHeader breadcrumbs={breadcrumbs} />;
    $[2] = breadcrumbs;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <SectionStrip brandedStyle={t2}>{t3}</SectionStrip>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AdSlot id="content-top" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = (labels as any).videoPage?.relatedMatches;
  let t7;
  if ($[8] !== t6) {
    t7 = <RelatedMatches showHeader={false} matchesLabel={t6} />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== post.content) {
    t8 = <PostBody content={post.content} />;
    $[10] = post.content;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = (labels as any).videoPage?.author;
  const t10 = (labels as any).videoPage?.authors;
  let t11;
  if ($[12] !== post.populatedAuthors || $[13] !== t10 || $[14] !== t9) {
    t11 = <PostAuthors authors={post.populatedAuthors} authorLabel={t9} authorsLabel={t10} />;
    $[12] = post.populatedAuthors;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = `post-${post.id}`;
  let t13;
  if ($[16] !== t12) {
    t13 = <DiscussionWidget entityId={t12} discussionLabel="Comments" className="mt-8" />;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t11 || $[19] !== t13 || $[20] !== t7 || $[21] !== t8) {
    t14 = <div className="flex-1 min-w-0 max-w-240">{t7}{t8}{t11}{t13}</div>;
    $[18] = t11;
    $[19] = t13;
    $[20] = t7;
    $[21] = t8;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SidebarContent />;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t14) {
    t16 = <div className="flex flex-col lg:flex-row gap-8">{t14}{t15}</div>;
    $[24] = t14;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <AdSlot id="content-bottom" />;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t16) {
    t18 = <div className="container mx-auto px-4 py-8 md:py-12 space-y-8">{t5}{t16}{t17}</div>;
    $[27] = t16;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t18 || $[30] !== t4) {
    t19 = <article className="min-h-screen">{t4}{t18}</article>;
    $[29] = t18;
    $[30] = t4;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  return t19;
}